import { projectRoutes } from './PROJECTS/routes'
var r = []

r.push.apply(r, projectRoutes)
export const variableRoutes = r;


// WEBPACK FOOTER //
// ./src/CUSTOM/custom-modules/routes.js